import * as React from 'react';

export interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
}

export const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ className = '', orientation = 'horizontal', ...props }, ref) => (
    <div
      ref={ref}
      role="none"
      data-orientation={orientation}
      className={`shadcn-separator ${className}`.trim()}
      {...props}
    />
  )
);
Separator.displayName = 'Separator';
